import { Button, Modal } from "react-bootstrap";

export default function NFSeModalVisualizarISSConsulta({ show, cidadeData, servicoData, issData, handleClose }:iProps) {
    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            onHide={() => { handleClose() }}
            // centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <b>GovBR - Consultar ISS: {cidadeData.label}</b><br></br>
                    <b>Serviço: {servicoData.label}</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <textarea id="modal_iss" className='form-control' style={{height: "512px"}} value={JSON.stringify(issData, null, 4)} readOnly></textarea>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => { handleClose() }}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}
interface iProps {
    show: boolean
    cidadeData: any
    servicoData: any
    issData: any
    handleClose: any
}
